import { useIntl } from 'react-intl';

export const useFavouriteStationsButtonText = () => {
  const { formatMessage } = useIntl();

  return formatMessage({ id: 'favouriteStations' });
};
